<template>
  <tr class="mtable-header">
    <th
      v-for="(item, index) in cols"
      :key="index"
      :style="'width:' + (item.width ? item.width : 'auto') + ';'"
      class="mtable-th"
      :class="line ? 'mtable-line' : ''"
    >
      <template v-if="item.label == 'index'"> * </template>
      <template v-else>{{ item.label }}</template>
    </th>
  </tr>
</template>

<script>
export default {
  name: "TableHeader",
  props: {
    cols: {
      type: Array,
      default: () => [],
    },
    line: {
      type: Boolean,
      default: true,
    },
  },
  created() {},
};
</script>

<style lang="less" scoped>
.mtable-header {
  border-bottom: solid 1px #00000060;

  .mtable-th {
    padding: 0.5rem;
    font-size: large;
  }
  .mtable-line {
    border: solid 1px #00000040;
  }
}
</style>